/* p3d.js — reveal-on-scroll for the Premium PDP sections (.p3d).
   Adds .p3d-shown to every .p3d [data-reveal] element so the content
   becomes visible. Idempotent (guarded) so it can be included from
   several sections without running twice. Includes a safety timeout so
   content is NEVER left hidden, even if IntersectionObserver fails. */
(function(){
  if (window.__p3dReady) return;
  window.__p3dReady = true;

  function reveal(el){
    var d = parseInt(el.getAttribute('data-d') || '0', 10);
    if (d) { el.style.transitionDelay = d + 'ms'; }
    el.classList.add('p3d-shown');
  }

  function init(){
    var nodes = [].slice.call(document.querySelectorAll('.p3d [data-reveal]'));
    if (!nodes.length) return;
    var vh = window.innerHeight || 800;

    // Reveal anything already in (or near) the viewport right away.
    nodes.forEach(function(el){
      if (el.getBoundingClientRect().top < vh * 1.1) { reveal(el); }
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if (en.isIntersecting) { reveal(en.target); io.unobserve(en.target); }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });
      nodes.forEach(function(el){
        if (!el.classList.contains('p3d-shown')) { io.observe(el); }
      });
    } else {
      nodes.forEach(reveal);
    }

    // Safety net: never leave content hidden.
    setTimeout(function(){
      nodes.forEach(function(el){ el.classList.add('p3d-shown'); });
    }, 2500);
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();
